import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { IconSvgComponent } from '../icon/icon.component';
import { MeatballMenuOption } from './meatball-menu-options.model';

@Component({
  standalone: true,
  imports: [NgbDropdownModule, IconSvgComponent, IconSvgComponent],
  selector: 'rx-applications-meatball-menu',
  templateUrl: './meatball-menu.component.html',
  styleUrls: ['./meatball-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeatballMenuComponent {
  options = input<MeatballMenuOption[]>([]);
  onItemClick = output<MeatballMenuOption>();
}
